import { url } from 'src/app/core/utilities/utility-functions';
import { Injectable } from '@angular/core';
import { BaseService } from '@shared/services/base-service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { ClassificationDto } from '@models/competition/dtos/classification/classification-dto';
import { ClassificationsByParameterizationDto } from '@models/competition/dtos/classification/classifications-by-parameterization-dto';
import { ResponseDto } from '@models/exceptions/response-dto';
import { IPage } from '@models/pagination/page';
import { toParams } from 'src/app/core/utilities/utility-functions';

@Injectable({
  providedIn: 'root'
})
export class ClassificationService extends BaseService {

  urlApi = environment.apiUrl + '/v1/classificacoes';

  searchClassificationsByKey(cheNrId?: number): Observable<ResponseDto<IPage<ClassificationDto>>> {
    return this.http.get<ResponseDto<IPage<ClassificationDto>>>(url(this.urlApi, 'listar-classificacoes', cheNrId));
  }

  searchClassificationsByParameterization(params: {
    eveNrId?: number;
    petNrId?: number;
  }): Observable<ResponseDto<ClassificationsByParameterizationDto[]>> {
    return this.http.get<ResponseDto<ClassificationsByParameterizationDto[]>>(
      url(this.urlApi, 'parametrizacoes'),
      { params: toParams(params) },
    );
  }
}
